export class StateScopeSettings {
  scope = 'shared';

  constructor(init: Partial<StateScopeSettings>) {
    this.scope = init.scope ?? this.scope;
  }
}
